/*
 * @Author: Ryan
 * @Date: 2026-02-02
 * @Description: SEO sections entry file for ai-image-translator page
 */
import React from 'react';

import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import FeaturesSection from './FeaturesSection';
import HowToUseSection from './HowToUseSection';
import LanguageSection from './LanguageSection';
import TestimonialsSection from './TestimonialsSection';
import UseCasesSection from './UseCasesSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      <LanguageSection />
      <HowToUseSection />
      <FeaturesSection />
      <UseCasesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

// 导出 ImageComparePlayer 供外部使用
export { default as ImageComparePlayer } from './ImageComparePlayer';
